import React, { Component } from 'react';
import './App.css';
import Center from './Center';
import FlexCenter from './FlexCenter';
import Fade from 'react-reveal/Fade';

class UnitTable extends Component {
  constructor(){
    super()
    this.launchModal = this.launchModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.state = {
      modalClass: ' fp-modal-closed',
      modalLink: ''
    }
  }
  componentWillMount(){
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false)
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false)
  }
  escFunction(event){
    if(event.keyCode === 27){
      this.closeModal()
    }
  }
  launchModal(x, trueFalse){
    // console.log("launchModal success")
    var drift = document.getElementById('drift-widget')
    if(drift) drift.style.display = "none"
    this.setState({modalClass: '', modalLink: x, floorplan: trueFalse})
    // console.log('x', x)
  }
  closeModal(){
    var drift = document.getElementById('drift-widget')
    if(drift) drift.style.display = "block"
    this.setState({modalClass: ' fp-modal-closed'})
  }
  render(){
    var t = this, s = this.state, p = this.props;

    if(s.floorplan){ // launches floorplan or 3d tour matterport-iframe
      var floorplan_3DTour = (<div className="matterport-iframe" style={{backgroundImage: s.modalLink, backgroundSize: 'contain', height: '80vh', width: 'auto', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'}}/>);
    } else {
      var floorplan_3DTour = (<iframe className="matterport-iframe" width='853' height='480' src={s.modalLink} frameborder='0' allowfullscreen allow='vr'></iframe>);
    }

    // console.log("p.unitArray", p.unitArray);

    return (
      <div className="ut-container">
        <table className="unit-table-el unit-table-hide">
          <tbody>
            <tr className="tableHeadingRow">
              <th className="categoryText unitNumCol">Unit #</th>
              <th className="categoryText typeCol">Type</th>
              <th className="categoryText typeCol">Property</th>
              <th className="categoryText sqFtCol">Sq Ft</th>
              <th className="categoryText rateCol">Price / Mo</th>
              <th className="categoryText floorPlanCol">Floor Plan</th>
            </tr>
            {p.unitArray.map((i) => {
              // console.log("i", i);
              if(i.available || !p.available){
                var tour3D = (<button className="button-2d-3d floorplan-2d" onClick={() => this.launchModal(i.link, false)}><p>3D Tour </p></button>);
                var floorplan2d = (<button className="button-2d-3d floorplan-3d" onClick={() => this.launchModal(i.floorplan2d, true)}><p>Floorplan</p></button>);
                // if(i.link === ""){
                //   var tour3D = (<button disabled={true} class="button-2d-3d floorplan-2d disabled"><p>Coming Soon</p></button>);
                // }
                // if(i.floorplan2d === ""){
                //   var floorplan2d = (<button disabled={true} class="button-2d-3d floorplan-3d disabled"><p>Coming Soon</p></button>);
                // }
                if(i.link === ""){
                  var tour3D = (<div></div>);
                }
                if(i.floorplan2d === ""){
                  var floorplan2d = (<div></div>);
                }

                return(
                  <tr className="tableDataRow">
                    <th>{i.unitNum}</th>
                    <th>{i.bedroomText}</th>
                    <th>{i.property}<br/>{i.city}</th>
                    <th>{i.sqFt}</th>
                    <th>{i.price}</th>
                    <th>
                      {tour3D}
                      {floorplan2d}
                      {/*<button className="button-2d-3d floorplan-2d" onClick={() => this.launchModal(i.link, false)}>
                          <p>3D Tour</p>
                      </button>
                      <button className="button-2d-3d floorplan-3d" onClick={() => this.launchModal(i.floorplan2d, true)}>
                        <p>Floorplan</p>
                      </button>*/}
                    </th>
                  </tr>
                );
              }
              })}
          </tbody>
        </table>
            {p.unitArray.map((i) => {
              if(i.available || !p.available){
                var tour3D = (<button className="button-2d-3d floorplan-2d" onClick={() => this.launchModal(i.link, false)}><p>3D Tour </p></button>);
                var floorplan2d = (<button className="button-2d-3d floorplan-3d" onClick={() => this.launchModal(i.floorplan2d, true)}><p>Floorplan</p></button>);
                // if(i.link === ""){
                //   var tour3D = (<button disabled={true} class="button-2d-3d floorplan-2d"><p>Coming Soon</p></button>);
                // }
                // if(i.floorplan2d === ""){
                //   var floorplan2d = (<button disabled={true} class="button-2d-3d floorplan-2d"><p>Coming Soon</p></button>);
                // }
                if(i.link === ""){
                  var tour3D = (<div></div>);
                }
                if(i.floorplan2d === ""){
                  var floorplan2d = (<div></div>);
                }
                // console.log("tour3D", tour3D)
                // console.log("floorplan2d", floorplan2d)
              return (
                <div className="hide-table-large">
                  <div className="floorplanMobileHeading"><span className="floorplanMobileUnit">{"#" + i.unitNum + " " + i.property}</span><br/><span className="floorplanMobileCity">{i.city}</span></div>
                  <table className="unit-table-el">
                    <tbody className="unit-table-el">
                        <tr style={{borderTop: 'none', backgroundColor: '#f7f7f7'}} className="tableDataRow">
                          <th className="categoryText">Type</th>
                          <th className="categoryText sqFtCol">Sq Ft</th>
                          <th className="categoryText rateCol">Price / Mo</th>
                          <th className="categoryText floorPlanCol">Floor Plan</th>
                        </tr>
                        <tr className="tableDataRow">
                          <th>{i.bedroomText}</th>
                          <th>{i.sqFt}</th>
                          <th>{i.price}</th>
                          <th>
                            {tour3D}
                            {floorplan2d}
                          </th>
                        </tr>
                    </tbody>
                  </table>
                  <div className="amenitiesColBody">
                    <span style={{fontWeight: 'bold'}}>Amenities:</span> {i.amenities}
                  </div>
                </div>
              )
            }
              })}

        <div className={"floor-plans-matterport" + this.state.modalClass}>
          <Center width="100%">
            <div className="floor-plans-modal-close" style={{fontFamily: 'proxima-nova'}}>
              <FlexCenter><p className="fp-close-text" onClick={this.closeModal}>Close</p></FlexCenter>
            </div>
              {floorplan_3DTour}
              {/*<img src='s.modalLink'/>
              <iframe className="matterport-iframe" width='853' height='480' src={s.modalLink} frameborder='0' allowfullscreen allow='vr'></iframe>*/}
          </Center>
        </div>
      </div>
    )
  }
}

export default UnitTable;


/*


*/



// WEBPACK FOOTER //
// ./src/UnitTable.js